import keys from '@debbie/common/dist/cache/keys.js';
import { validateEmail } from '@debbie/common/dist/index.js';
import { UserState } from '@debbie/common/dist/users/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as creditorUsersAPI from '@debbie/cortex/dist/api/creditor-users.js';
import { creditorUsersEntity, useCreditorUsers, } from '@debbie/cortex/dist/creditor-users/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import { errorNotification, successNotification } from '../../utils/errors.js';
import { PlusSquare } from '../Icons/index.js';
import { Badge, Button, Errors, Input, Modal, Panel, PlaceholderLoader, Well, } from '../index.js';
import PowerTable from '../PowerTable.js';
// The colleagues on one creditor, with an invite flow pinned to that
// creditor. Backed by the creditor scoped /iam/:tid/creditor-users resource —
// the server only ever answers for creditors the caller has access to.
const CreditorUsers = (props) => {
    const lang = useSelector((s) => s.lang);
    const usersLoadable = useCreditorUsers(props.creditorId);
    const users = h.hasData(usersLoadable) ? usersLoadable.data : null;
    const [inviteModalOpen, setInviteModalOpen] = useState(false);
    return (React.createElement(Panel, { header: React.createElement("div", null,
            lang.navigation.settingsUsers,
            ' ',
            React.createElement(Button, { style: { float: 'right' }, onClick: () => setInviteModalOpen(true), size: "mini" },
                lang.users.inviteUser,
                ' ',
                React.createElement(PlusSquare, { style: { margin: '0.1em 0 -0.1em' } }))) },
        h.isError(usersLoadable) ? (React.createElement(Errors, { errors: [usersLoadable.error.message] })) : users === null ? (React.createElement(PlaceholderLoader, null)) : users.length === 0 ? (React.createElement("h3", { style: { textAlign: 'center', opacity: 0.7 } }, lang.users.noUsers)) : (React.createElement(PowerTable, { data: users, genKey: (user) => user.id, pagination: { type: 'pages', pageSize: 25 }, searchable: true, toSearchStr: (user) => `${user.firstName} ${user.lastName} ${user.email ?? ''}`, values: {
                firstName: {
                    label: lang.users.name,
                    toCmp: (firstName) => firstName,
                    map: (_, user) => (React.createElement("b", null,
                        user.firstName,
                        " ",
                        user.lastName)),
                },
                email: {
                    label: lang.users.email,
                    toCmp: (email) => email ?? '',
                    map: (email) => React.createElement("span", null, email),
                },
                state: {
                    label: '',
                    toCmp: (state) => state,
                    map: (state) => (React.createElement(Badge, { theme: state === UserState.ACTIVE
                            ? THEME.SUCCESS
                            : THEME.COLOR_ACCENT }, state === UserState.ACTIVE
                        ? lang.users.stateActive
                        : lang.users.stateInvited)),
                },
                createdAt: {
                    label: '',
                    toCmp: (createdAt) => createdAt,
                    map: (createdAt) => (React.createElement("span", null, moment(createdAt).format(THEME.DATE_FORMAT))),
                },
            } })),
        inviteModalOpen && (React.createElement(InviteUserModal, { creditorId: props.creditorId, onToggle: () => setInviteModalOpen(false) }))));
};
const InviteUserModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const inviteMutation = useMutation(async () => {
        await creditorUsersAPI.invite(props.creditorId, {
            firstName,
            lastName,
            email,
        });
        q.invalidate(keys.write.create(creditorUsersEntity));
        successNotification(lang, 'create', lang.errorEntities.user);
        props.onToggle();
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.user);
        },
    });
    return (React.createElement(Modal, { header: lang.users.inviteUser, onToggle: props.onToggle, maxWidth: "400px" },
        React.createElement(Well, null,
            React.createElement(Input, { placeholder: lang.users.firstName, value: firstName, onChange: (e) => setFirstName(e.target.value) }),
            React.createElement(Input, { placeholder: lang.users.lastName, value: lastName, onChange: (e) => setLastName(e.target.value) }),
            React.createElement(Input, { placeholder: lang.users.email, value: email, onChange: (e) => setEmail(e.target.value) }),
            React.createElement(Button, { block: true, disabled: !(firstName && lastName && validateEmail(email)), loading: inviteMutation.isLoading, onClick: () => inviteMutation.mutate() }, lang.users.inviteUser))));
};
export default CreditorUsers;
//# sourceMappingURL=CreditorUsers.js.map